// Gestione classe 'webview' sul body
// La classe viene aggiunta principalmente dallo script inline in theme.liquid (prima del paint)
// Questo script è un fallback per i layout che non hanno quello script (splash, scroll).
//
// Viene incorporato nel <head> (vedi theme-scripts.liquid), dove `document.body` non
// esiste ancora: leggerlo subito lanciava un TypeError proprio nelle webview, cioè
// l'unico caso in cui questo fallback serve. Se il body non c'è si aspetta il
// DOMContentLoaded.

(function () {
  const ua = navigator.userAgent.toLowerCase();
  if (!ua.includes('mumble-app') && !ua.includes('shoppy')) return;

  const mark = () => document.body.classList.add('webview');
  if (document.body) mark();
  else document.addEventListener('DOMContentLoaded', mark, { once: true });
})();
